export default {
  meta: {
    title: '经销商管理',
  },
};
